<template>
  <div class="parent-container">

    <div class="tool-bar">
      <button @click="handleMaximize" v-if="isCanvasMinimized">最大化</button>
      <button @click="handleNewBlank">空白画板</button>
      <button @click="handleCaptureAsBg">截图</button>
      <button @click="handleTransparentBg">透明画板</button>
    </div>

    <CanvasWrap
      v-show="showCanvas"
      ref="canvasWrap"
      @minimize="handleCanvasMinimize"
      @save-success="handleSaveSuccess" 
    />

  </div>
</template>

<script>
import CanvasWrap from './canvasWrap.vue'

export default {
  components: { CanvasWrap },
  data() {
    return {
      showCanvas: false,
      isCanvasMinimized: false,
      // 画板数组（存放所有保存的图片地址）
      canvasList: [],
      // 待执行的操作（空白/截图/透明）
      pendingAction: null
    }
  },
  methods: {
    // 接收最小化
    handleCanvasMinimize(status) {
      this.isCanvasMinimized = status
      this.showCanvas = !status
    },

    // 最大化
    handleMaximize() {
      this.showCanvas = true
      this.$refs.canvasWrap.toggleMinimize()
    },

    // ==========================
    // 三个按钮统一入口
    // ==========================
    handleNewBlank() {
      this.checkBeforeAction('blank')
    },
    handleCaptureAsBg() {
      this.checkBeforeAction('capture')
    },
    handleTransparentBg() {
      this.checkBeforeAction('transparent')
    },

    // ==========================
    // 检查是否需要提示保存
    // ==========================
    checkBeforeAction(action) {
      this.pendingAction = action

      // 有最大化 → 需要询问保存
      if (this.isCanvasMinimized) {
        if (confirm('是否保存当前画板内容？')) {
          // 通知子组件保存
          this.$refs.canvasWrap.saveCanvas()
        } else {
          // 不保存 → 直接执行新操作
          this.doAction()
        }
      } else {
        // 没有最大化 → 直接追加
        this.canvasList.push('')
        this.doAction()
      }
    },

    // ==========================
    // 子组件保存成功 → 回调
    // ==========================
    handleSaveSuccess(imageUrl) {
      // 把保存好的地址放进数组
      this.canvasList.push(imageUrl)
      // 再追加一个空地址
      this.canvasList.push('')
      // 执行操作
      this.doAction()
    },

    // ==========================
    // 执行最终操作
    // ==========================
    doAction() {
      this.showCanvas = true
      const action = this.pendingAction

      if (action === 'blank') {
        this.$refs.canvasWrap.setParentBg({ type: 'white' })
        this.$refs.canvasWrap.clearCanvas()
      }
      if (action === 'capture') {
        const canvas = this.$refs.canvasWrap.$refs.drawCanvas
        const url = canvas.toDataURL('image/png')
        this.$refs.canvasWrap.setParentBg({ type: 'image', imageUrl: url })
      }
      if (action === 'transparent') {
        this.$refs.canvasWrap.setParentBg({ type: 'transparent' })
      }
    }
  }
}
</script>

<style scoped>
.parent-container {
  width: 100vw;
  height: 100vh;
  position: relative;
}

.tool-bar {
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
  z-index: 9999;
}

.tool-bar button {
  padding: 8px 12px;
  border: none;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
}
</style>